export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-testid="logo-mark">
    <rect width="64" height="64" rx="16" fill="#D4FF00" />
    <circle cx="32" cy="32" r="18" fill="#08090C" />
    <circle cx="26" cy="26" r="3.4" fill="#D4FF00" />
    <circle cx="38" cy="26" r="3.4" fill="#D4FF00" />
    <circle cx="32" cy="35" r="3.4" fill="#D4FF00" />
    <circle cx="24" cy="37" r="2.6" fill="#D4FF00" />
    <circle cx="40" cy="37" r="2.6" fill="#D4FF00" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-xl font-extrabold uppercase leading-none tracking-tight text-white">
      PopUp <span className="text-volt">Pickleball</span>
    </span>
  </span>
);
